const colors = {
  primary: "#b5a262", // Primary color used for buttons and highlights
  secondary: "#13294b", // Secondary color used for headings and text
  lightBg: "#f8f4e8", // Light background for sections
  darkBg: "#0f1f38", // Dark background for sections
  white: "#ffffff", // White for text and backgrounds
  textMuted: "#4a4a4a", // Muted text for secondary information
  highlight: "#b22234", // Highlight color for hover states
};

const typography = {
  fontFamily: "Georgia, serif", // Global font family
  defaultHeadingWeight: "bold", // Default font weight for headings
  defaultTextSize: "16px", // Default font size for text
};

const shadows = {
  defaultShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Default shadow for buttons and cards
  imageShadow: "0px 8px 10px rgba(0, 0, 0, 0.15)", // Default shadow for images
  cardShadow: "0px 10px 20px rgba(0, 0, 0, 0.1)", // Default shadow for cards
};

const theme = {
  headerBg: colors.primary,
  linkBg: colors.primary,
  linkText: colors.secondary,
  linkHoverText: colors.white,
  iconBg: colors.primary,
  iconHoverBg: colors.secondary,
  fontFamily: typography.fontFamily,

  footerBg: colors.lightBg,
  titleText: colors.secondary,
  footerLinkText: colors.secondary,
  footerLinkHoverText: colors.highlight,
  footerDivider: colors.secondary,
  footerSocialIconText: colors.secondary,
  footerSocialIconHoverText: colors.highlight,
  bgImage: "https://readymadeui.com/bg-image.webp",

  whyUsSection: {
    textColor: colors.secondary,
    fontFamily: typography.fontFamily,
    headingTextColor: colors.secondary,
    buttonBackground: colors.secondary,
    buttonText: colors.white,
    buttonHoverBackground: colors.white,
    buttonHoverText: colors.secondary,
    buttonShadow: shadows.defaultShadow,
    imageShadow: shadows.imageShadow,
  },

  highlightsSection: {
    backgroundColor: colors.lightBg,
    textColor: colors.secondary,
    fontFamily: typography.fontFamily,
    headingTextColor: colors.secondary,
    buttonBackground: colors.white,
    buttonBorderColor: colors.primary,
    buttonTextColor: colors.secondary,
    buttonHoverBackground: colors.primary,
    buttonHoverTextColor: colors.white,
    imageBorderColor: colors.primary,
    arrowButtonBackground: colors.secondary,
    arrowButtonHoverBackground: colors.primary,
    arrowButtonTextColor: colors.white,
  },

  supportiveNetworkSection: {
    backgroundColor: colors.secondary,
    textColor: colors.white,
    headingTextColor: colors.white,
    buttonBackground: colors.primary,
    buttonTextColor: colors.secondary,
    buttonHoverBackground: colors.white,
    buttonHoverTextColor: colors.secondary,
    fontFamily: typography.fontFamily,
  },

  librariesSection: {
    backgroundColor: "#1a1a1a",
    cardBackground: colors.white,
    headingTextColor: "#333333",
    subHeadingTextColor: "#333333",
    textColor: colors.textMuted,
    linkTextColor: "#b5a262",
    linkHoverTextColor: colors.secondary,
    fontFamily: typography.fontFamily,
    imageShadow: shadows.imageShadow,
  },

  campusLifeSection: {
    backgroundColor: colors.lightBg,
    fontFamily: typography.fontFamily,
    headingTextColor: colors.secondary,
    paragraphTextColor: "#333333",
    cardShadow: shadows.cardShadow,
    imageShadow: shadows.defaultShadow,
    cardTitleTextColor: colors.secondary,
    cardTextColor: colors.textMuted,
    linkTextColor: colors.primary,
    linkHoverTextColor: colors.secondary,
  },

  staffExperienceSection: {
    fontFamily: typography.fontFamily,
    textColor: colors.secondary,
    headingTextColor: colors.primary,
    imageShadow: "0 4px 30px rgba(0, 0, 0, 0.2)",
  },

  facilitiesSection: {
    backgroundColor: colors.lightBg,
    textColor: colors.secondary,
    headingTextColor: colors.secondary,
    buttonBackground: colors.primary,
    buttonTextColor: colors.secondary,
    buttonHoverBackground: colors.secondary,
    buttonHoverTextColor: colors.white,
    fontFamily: typography.fontFamily,
  },

  achievementsSection: {
    backgroundColor: colors.darkBg,
    textColor: colors.white,
    fontFamily: typography.fontFamily,
    headingTextColor: colors.primary,
    buttonBackground: colors.primary,
    buttonTextColor: colors.secondary,
    buttonHoverBackground: colors.white,
    buttonHoverTextColor: colors.secondary,
    imageShadow: shadows.imageShadow,
  },

  visionMissionSection: {
    backgroundColor: colors.white,
    textColor: colors.textMuted,
    fontFamily: typography.fontFamily,
    headingTextColor: colors.secondary,
    borderColor: colors.primary,
    buttonBackground: colors.primary,
    buttonText: colors.white,
    buttonHoverBackground: colors.secondary,
    buttonHoverText: colors.white,
    imageShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  },

  SuccessStories: {
    backgroundColor: colors.secondary,
    textColor: colors.white,
    buttonBackground: colors.primary,
    buttonText: colors.secondary,
    buttonHoverBackground: colors.white,
    buttonHoverText: colors.secondary,
    fontFamily: typography.fontFamily,
  },

  Events: {
    sectionBackground: colors.secondary,
    titleColor: colors.white,
    cardBackground: colors.white,
    cardShadow: shadows.cardShadow,
    titleFontFamily: typography.fontFamily,
    eventTitleColor: "#333333",
    eventTypeColor: "#ff6347",
    eventTimeColor: "#666666",
    overlayBackground: "rgba(0, 0, 0, 0.5)",
    overlayTextColor: colors.white,
  },

  ScholarshipExam: {
    fontFamily: typography.fontFamily,
    headingColor: colors.secondary,
    headingSize: "text-4xl",
    headingFontWeight: "font-bold",
    headingLetterSpacing: "tracking-wider",
    button1: {
      backgroundColor: colors.primary,
      hoverBackgroundColor: "#a28d54",
      textColor: colors.white,
      fontWeight: "font-semibold",
      fontSize: "text-xl",
      shadow: "shadow-lg",
    },
    button2: {
      backgroundColor: colors.secondary,
      hoverBackgroundColor: "#0e2f88",
      textColor: colors.white,
      fontWeight: "font-semibold",
      fontSize: "text-xl",
      shadow: "shadow-lg",
    },
  },

  MessageCards: {
    backgroundColor: colors.white,
    boxShadow: "0 0 15px rgba(181, 162, 98, 0.5)",
    hoverBoxShadow: "0 0 20px rgba(181, 162, 98, 0.8)",
    imageBoxShadow: "0 0 10px rgba(181, 162, 98, 0.5)",
    hoverImageBoxShadow: "0 0 15px rgba(181, 162, 98, 0.8)",
    titleColor: colors.secondary,
    messageColor: "#5a5a5a",
    authorColor: "#606060",
    dividerColor: colors.primary,
    buttonTextColor: colors.primary,
    buttonTextHoverColor: colors.primary,
  },
};

export default theme;
